<template>
  <div class="content-padding">
    <v-card>
      <v-toolbar color="primary" dark class="elevation-0">
        <v-toolbar-title>Contratos</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-overlay :value="overlay" z-index="3">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card-title>
        <v-icon>account_circle</v-icon>
        <strong>{{ name }}</strong>
      </v-card-title>

      <v-data-table :headers="headers" :items="items" no-data-text="No se encontraron contratos" footer-props.items-per-page-text="filas por página" v-if="!progress">
        <!-- <template slot="item" slot-scope="agreement">
          <tr @click="printAgreement(agreement.item)" class="pointer" slot="activator">
            <td></td>
            <td>{{ agreement.item.jobTitleName }}</td>
            <td>{{ $moment(agreement.item.agreementDateStart).format('D/M/YYYY') }}</td>
            <td>{{ agreement.item.agreementDateEnd ? $moment(agreement.item.agreementDateEnd).format('D/M/YYYY') : 'Ninguna' }}</td>
            <td>{{ agreement.item.agreementIsRetire || agreement.item.agreementIsAnnule ? 'Finalizado' : 'Vigente' }}</td>
            <td></td>
          </tr>
        </template> -->
        <template v-slot:item.agreement="{ item }">
          <v-btn icon @click="printAgreement(item)">
            <v-icon>print</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.charge="{ item }">
          <v-row>
            <v-col>{{ item.jobTitleName }}</v-col>
          </v-row>
        </template>
        <template v-slot:item.initialDate="{ item }">
          <v-row>
            <v-col>{{ item.agreementDateStart | formatToDate }}</v-col>
          </v-row>
        </template>
        <template v-slot:item.finalDate="{ item }">
          <v-row>
            <v-col>{{ item.agreementDateEnd ? $moment(item.agreementDateEnd).format('DD/M/YYYY') : 'Ninguna' }}</v-col>
          </v-row>
        </template>
        <template v-slot:item.state="{ item }">
          <v-row>
            <v-col>{{ item.jobTitleName }}</v-col>
          </v-row>
        </template>
      </v-data-table>

      <view-certificate ref="dialog"></view-certificate>
    </v-card>
  </div>
</template>

<script>
import { getToken } from '@/assets/js/shared/utils.js'

export default {
  name: 'certificate-index',
  data() {
    return {
      overlay: false,
      progress: true,
      loading: false,
      dialog: false,
      agreementSelected: {},
      name: getToken().prsName,
      person: {},
      headers: [
        {
          text: 'Ver certificado',
          align: 'center',
          sortable: false,
          value: 'agreement'
        },
        {
          text: 'Cargo',
          align: 'left',
          sortable: false,
          value: 'charge'
        },
        {
          text: 'Fecha de inicio',
          align: 'left',
          sortable: false,
          value: 'initialDate'
        },
        {
          text: 'Fecha de finalización',
          align: 'left',
          sortable: false,
          value: 'finalDate'
        },
        {
          text: 'Estado',
          align: 'left',
          sortable: false,
          value: 'state'
        }
      ],
      items: [{}]
    }
  },
  methods: {
    getPerson() {
      this.$http.get('common/people/' + getToken().personId).then(
        (response) => {
          // console.log("person >>> ", response.body);
          this.person = response.body
          this.$refs.dialog.person = response.body
        },
        (response) => {
          console.error(response)
        }
      )
    },
    getAgreement() {
      this.$http.get(`common/people/${getToken().personId}/agreements`).then(
        (response) => {
          // console.log("agreement >>> ", response.body);
          this.items = response.body
        },
        (response) => {
          console.error(response)
        }
      )
    },
    getTemplateLetter() {
      this.$http.get('hrm/companies').then(
        (response) => {
          // console.log("letter >>> ", response.body);
          this.$refs.dialog.myCompany = response.body
          this.overlay = false
        },
        (response) => {
          console.error(response)
        }
      )
    },
    getCompany() {
      this.$http
        .get('common/companies/authenticated')
        .then((response) => {
          this.$refs.dialog.company = response.body
        })
        .catch((error) => {
          console.error(`${this.$options.name} > methods > getCompany > $http.get > error`, error)
        })
    },
    printAgreement(agreement) {
      this.loading = true
      var promise = new Promise(function (resolve) {
        resolve('')
      })
      console.log('%c⧭', 'color: #00bf00', this.$refs.dialog.company.companyLogo)
      if (this.$refs.dialog.company.companyLogo) {
        promise = this.$http.get('common/attachments/signed', {
          params: { redirect: false, url: this.$refs.dialog.company.companyLogo }
        })
      }

      promise
        .then(({ data }) => {
          this.$refs.dialog.company.companyLogoSignedUrl = data
        })
        .then(() => {
          this.$refs.dialog.agreement = agreement

          if (this.$refs.dialog.myCompany) return this.$refs.dialog.open()

          this.$swal({
            icon: 'error',
            title: this.$t('errorOcurred'),
            text: this.$t('certificateNotMade')
          })
        })
        .catch((error) => {
          console.error(`${this.$options.name} > methods > getCompany > $http.get > error`, error)

          this.$swal({
            icon: 'error',
            title: this.$t('errorOcurred'),
            text: this.$t('certificateNotMade')
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  created() {
    this.overlay = true
    this.getCompany()
    this.getAgreement()
    this.getPerson()
    this.getTemplateLetter()
  },
  mounted: function () {
    if (this.person && this.items) {
      this.progress = false
    }
  }
}
</script>

<style>
.pointer {
  cursor: pointer;
}

.teen {
  font-weight: 100;
  font-size: 15px;
}
</style>
